<template>
  <div id='playlist'>
    <div class="playBox">
      <div class="pd25">
        <mTitle :isShowRightText="false" :title="'政策法规'" class="pcboxs"></mTitle>

        <mTitle :isShowRightText="false" :isPaddingLeft="true" :title="'政策法规'" class="mobileBox"></mTitle>
      </div>


      <div class="margin15 pcBox pd25 tableBox">
      <el-table :data="tableData" style="width: 100%">
        <el-table-column type="index" align="center" label="序号" width="80">
        </el-table-column>
        <el-table-column prop="name" align="center"  label="团体名称" width="180">
        </el-table-column>
        <el-table-column prop="title" align="center"  label="标准名称" width="380">
        </el-table-column>
        <el-table-column prop="ref" label="标准编号">
        </el-table-column>
        <el-table-column prop="release" label="公布日期">
        </el-table-column>
        <el-table-column prop="address" label="操作" width="120">
          <template #default="{ row }">
            <el-button type="text" size="small" @click="toSingerDetail(row.xid)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="margin15 mobileBox" style="padding:0 10px">
      <div class="purchaseBox" v-for="item in tableData" @click="toSingerDetail(item.xid)">
        <div class="purchaseTitle">{{item.title}}</div>
        <div class="purchaseContent">
          <div class="lin20">团体名称：{{item.name}}</div>
          <div class="lin20">标准编号：{{item.ref}}</div>
          <div class="lin20">发布日期：{{item.release}}</div>
        </div>
      </div>
    </div>
      <div class="paginBox" >
        <div class="countNumber">
          共{{count}}条
        </div>
        <div class="rightPagin">
          <el-pagination
                    @size-change="sizePagination"
          @current-change="currentPagination"
          :pager-count="3"
          :page-size="filters.pageSize"
  background
  layout="prev, pager, next"
  :total="count">
</el-pagination>
        </div>

</div>
    </div>




  </div>
</template>

<script>
import mTitle from "@/components/TitleHead/index.vue";
export default {
  name: 'Playlist',
  components: { mTitle },
  data() {
    return {
      count:0,
      filters:{
        currPage:1,
        pageSize:12
      },
      tableData: [],
    }
  },
  mounted() {
 

    this.getList()
  },
  methods: {
    sizePagination(e){
      this.filters.currPage=e
      this.getList()
    },
    currentPagination(e){
      this.filters.currPage=e
      this.getList()
    },
    toSingerDetail(xid){
      this.$router.push({ path: "/singerDetail" ,query: { id: xid }});
    },
    getList(){
       this.$API.getStandard(this.filters).then(res => {
        console.log("res=========",res)
      if (res.code === 200) {
        this.tableData = res.data.list
        this.count = res.data.pageInfo.allRows
      }
    })
    },
    toDetail(){
      this.$router.push({path:'/singerDetail'})
    }
  },
}
</script>

<style scoped lang='less'>
//移动端
@media (max-width: 768px) {
  .pcBox{
    display: none !important;
  }
  .pcboxs{
    display: none !important;
  }
  .pd25{
    padding-top:10px
  }
  .purchaseContent{
font-weight: 500;
font-size: 14px;
color: #7A7A7A;
text-align: left;
font-style: normal;
text-transform: none;
padding: 10px;
  }
  .purchaseTitle{
    border-bottom: 1px solid #E8E8E8;
    padding: 10px;
  }
  .purchaseBox{
    width: 100%;
height: 140px;
background: #F3F3F3;
border-radius: 5px 5px 5px 5px;
opacity: 0.9;
margin-bottom: 11px;
margin-top: 10px;
  }
  ::v-deep .el-pagination.is-background .btn-prev{
  background: none;
}
::v-deep .el-pagination .btn-next .el-icon{
  font-size: 16px;
}
::v-deep .el-pagination .btn-prev .el-icon {
  font-size: 16px;
}
::v-deep .btn-next{
  width: 24px;
  height: 24px;
  background-color: #FFFFFF !important;
border-radius: 3px 3px 3px 3px;
border: 1px solid #E5E5E5;
}
::v-deep .btn-prev{
  width: 24px;
  height: 24px;
  background-color: #FFFFFF !important;
border-radius: 3px 3px 3px 3px;
border: 1px solid #E5E5E5;
}
::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active{
background: #FFFFFF;
border-radius: 3px 3px 3px 3px;
border: 1px solid #005431;
font-weight: bold;
font-size: 16px;
color: #005431;
text-align: center;
font-style: normal;
text-transform: none;
}
::v-deep .el-pagination.is-background .el-pager li{
border-radius: 3px 3px 3px 3px;
border: 1px solid #B4B4B4;
background: none;
width: 24px;
height: 24px;
font-weight: 500;
font-size: 13px;
color: #313131;
text-align: center;
font-style: normal;
text-transform: none;
line-height: 20px;
}
  .rightPagin{
    padding-right: 10px;
  }
  .countNumber{
font-weight: 500;
font-size: 13px;
color: #313131;
text-align: left;
font-style: normal;
text-transform: none;
  }
  .paginBox{
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-left:10px;
    padding-bottom: 20px;
  }
  .newsBox{
    padding-bottom: 20px;
  }

  .widBox{
    width: 52px;
    height: 52px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
  }
  .newsContent {
    margin-top: 8px;

font-weight: 500;
font-size: 13px;
color: #7A7A7A;
line-height: 24px;
text-align: left;
font-style: normal;
text-transform: none;
    white-space: nowrap;
    /* 不换行 */
    overflow: hidden;
    /* 隐藏溢出的内容 */
    text-overflow: ellipsis;
    /* 溢出部分显示省略号 (...) */
  }

  .newsTitle {
font-weight: 800;
font-size: 16px;
color: #313131;
text-align: left;
font-style: normal;
text-transform: none;
    white-space: nowrap;
    /* 不换行 */
    overflow: hidden;
    /* 隐藏溢出的内容 */
    text-overflow: ellipsis;
    /* 溢出部分显示省略号 (...) */
  }
  .newRightBox {
    width: 80%;
    padding-left: 10px; /* 给右边内容留点空隙 */
  }
  .newsContentView {
    display: flex;
    justify-content: space-between;
    margin-top: 10px;
    padding:0 10px;
  }
  .moonFont {
    font-size: 16px;
  }

  .yearFont {
    font-size: 10px;
    margin-top: 3px;
  }
  .newLeftBox {
    background: #005431;
    color: #fff;

  }
  .pd25{
  }

  .playBox{
    width: 363px;
    margin: 10px auto;
  background: #fff;

}
}
//pc端
@media (min-width: 769px) {
  .tableBox{
    padding-top: 0 !important;
  }
  .margin15 {
    margin: 0 0 27px 0;
  }

  ::v-deep .el-button {
    font-weight: 500;
    font-size: 16px;
    color: #0F6136;
    line-height: 24px;
    text-align: left;
    font-style: normal;
    text-transform: none;
  }

  ::v-deep .el-table__row .cell {
    font-weight: 500;
    font-size: 16px;
    color: #313131;
    line-height: 24px;
    text-align: left;
    font-style: normal;
    text-transform: none;
  }

  ::v-deep .has-gutter .el-table__cell {
    background: #F7F7F7;
    font-weight: bold;
    font-size: 16px;
    color: #313131;
    line-height: 24px;
    text-align: left;
    font-style: normal;
    text-transform: none;
  }
  .mobileBox{
    display: none !important;
  }
  .countNumber{
font-weight: 500;
font-size: 16px;
color: #313131;
text-align: left;
font-style: normal;
text-transform: none;
}
.paginBox{
  display: flex;justify-content: space-between;padding: 40px 20px;align-items: center;
  }
::v-deep .el-pagination.is-background .btn-prev{
  background: none;
}
::v-deep .el-pagination .btn-next .el-icon{
  font-size: 18px;
}
::v-deep .el-pagination .btn-prev .el-icon {
  font-size: 18px;
}
::v-deep .btn-next{
  width: 36px;
  height: 36px;
  background-color: #FFFFFF !important;
border-radius: 3px 3px 3px 3px;
border: 1px solid #E5E5E5;
}
::v-deep .btn-prev{
  width: 36px;
  height: 36px;
  background-color: #FFFFFF !important;
border-radius: 3px 3px 3px 3px;
border: 1px solid #E5E5E5;
}
::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active{
background: #FFFFFF;
border-radius: 3px 3px 3px 3px;
border: 1px solid #005431;
font-weight: bold;
font-size: 16px;
color: #005431;
text-align: center;
font-style: normal;
text-transform: none;
}
::v-deep .el-pagination.is-background .el-pager li{
border-radius: 3px 3px 3px 3px;
border: 1px solid #B4B4B4;
background: none;
width: 36px;
height: 36px;
font-weight: 500;
font-size: 16px;
color: #313131;
text-align: center;
font-style: normal;
text-transform: none;
line-height: 35px;
}
  .yearFont {
    font-size: 12px;
    margin-top: 3px;
  }
.pd25{
  padding:25px;
}

  .newLeftBox {
    width: 60px;
    height: 60px;
    background: #005431;
    color: #fff;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
  }
.playBox{
  width: 1200px;
  margin: 0 auto;
  min-height: calc(100vh - 200px);
  background: #fff;
  margin-top: 10px;

}
.newsContentView {
    display: flex;
    margin-bottom: 14px;
    padding: 0 25px;
  }

  .swiperBox {
    display: flex;
    padding-top: 10px;
  }

  .newRightBox {
    margin-left: 10px;
    width: 1078px;
  }
  .widBox{
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
  }
  .newsContent {
    font-weight: 500;
    font-size: 14px;
    color: #7A7A7A;
    line-height: 24px;
    text-align: left;
    font-style: normal;
    text-transform: none;
    margin-top: 10px;
    white-space: nowrap;
    /* 不换行 */
    overflow: hidden;
    /* 隐藏溢出的内容 */
    text-overflow: ellipsis;
    /* 溢出部分显示省略号 (...) */
  }

  .newsTitle {
    font-weight: 800;
    font-size: 16px;
    color: #313131;
    text-align: left;
    font-style: normal;
    text-transform: none;
    white-space: nowrap;
    /* 不换行 */
    overflow: hidden;
    /* 隐藏溢出的内容 */
    text-overflow: ellipsis;
    /* 溢出部分显示省略号 (...) */
  }

  .newsBox {
    display: flex;
    flex-direction: column;
    height: 869px;
  }
}

</style>

